document.documentElement.classList.remove('no-js');
document.documentElement.classList.add('js');

(function () {
  var SELECTORS = {
    productSection: '[data-product-section]',
    mobileMenuPanel: '[data-mobile-menu-panel]',
    mobileMenuToggle: '[data-mobile-menu-toggle]',
    variantSelect: '[data-variant-select]',
    variantTrigger: '[data-variant-trigger]',
    selectedVariantLabel: '[data-selected-variant-label]',
    stickySelected: '[data-sticky-selected]',
    stickyImage: '[data-sticky-image]',
    galleryCurrent: '[data-gallery-current]',
    addButton: '[data-add-to-cart-button]',
    addText: '[data-add-to-cart-text]',
    addPrice: '[data-add-to-cart-price]',
    stickyPrice: '[data-sticky-price]',
    stickyCompare: '[data-sticky-compare]',
    stickyPriceRow: '[data-sticky-price-row]',
    priceWrapper: '[data-product-price-wrapper]',
    stickySubmit: '[data-sticky-submit]',
    currentPrice: '[data-current-price]',
    comparePrice: '[data-compare-price]',
    saleBadge: '[data-sale-badge]',
    mainImage: '[data-main-product-image]',
    lightboxImage: '[data-lightbox-image]',
    lightbox: '[data-lightbox]',
    lightboxPrev: '[data-lightbox-prev]',
    lightboxNext: '[data-lightbox-next]',
    lightboxCurrent: '[data-lightbox-current]',
    productThumb: '[data-product-thumb]',
    cartDrawer: '[data-cart-drawer]',
    cartItems: '[data-cart-drawer-items]',
    cartFooter: '[data-cart-drawer-footer]',
    cartOpen: '[data-cart-open]',
    cartClose: '[data-cart-close]',
    cartCount: '.ams-cart-count'
  };

  function qs(scope, selector) {
    return (scope || document).querySelector(selector);
  }

  function qsa(scope, selector) {
    return Array.prototype.slice.call((scope || document).querySelectorAll(selector));
  }

  function moneyText(value) {
    return value || '';
  }

  function closeMobileMenu() {
    var panel = qs(document, SELECTORS.mobileMenuPanel);
    var toggle = qs(document, SELECTORS.mobileMenuToggle);
    if (panel) panel.classList.remove('is-open');
    if (toggle) toggle.setAttribute('aria-expanded', 'false');
  }

  function setLoading(button, isLoading) {
    if (!button) return;
    button.classList.toggle('is-loading', Boolean(isLoading));
    button.setAttribute('aria-busy', isLoading ? 'true' : 'false');
  }

  function getSelectedOption(select) {
    if (!select || select.selectedIndex < 0) return null;
    return select.options[select.selectedIndex];
  }

  function syncVariantCards(section, selectedId) {
    qsa(section, SELECTORS.variantTrigger).forEach(function (button) {
      var isSelected = String(button.getAttribute('data-variant-id')) === String(selectedId);
      button.classList.toggle('is-selected', isSelected);
      button.setAttribute('aria-checked', isSelected ? 'true' : 'false');
      if (isSelected) button.setAttribute('data-selected', 'true');
      else button.removeAttribute('data-selected');
    });
  }

  function setMainProductImage(section, imageUrl, imageAlt, mediaId, mediaIndex) {
    if (!section || !imageUrl) return;
    var mainImage = qs(section, SELECTORS.mainImage);
    var lightboxImage = qs(section, SELECTORS.lightboxImage);

    if (mainImage) {
      mainImage.classList.add('is-swapping');
      window.setTimeout(function () {
        mainImage.src = imageUrl;
        mainImage.alt = imageAlt || mainImage.alt || '';
        mainImage.classList.remove('is-swapping');
      }, 80);
    }

    if (lightboxImage) {
      lightboxImage.src = imageUrl;
      lightboxImage.alt = imageAlt || '';
    }

    qsa(section, SELECTORS.productThumb).forEach(function (thumb) {
      var isActive = Boolean(mediaId) && thumb.getAttribute('data-media-id') === String(mediaId);
      thumb.classList.toggle('is-active', isActive);
      if (isActive && !mediaIndex) mediaIndex = thumb.getAttribute('data-media-index');
    });

    var galleryCurrent = qs(section, SELECTORS.galleryCurrent);
    if (galleryCurrent && mediaIndex) galleryCurrent.textContent = mediaIndex;
  }

  function updateProductFromVariant(select, options) {
    options = options || {};
    var section = select && select.closest(SELECTORS.productSection);
    if (!section) return;

    var option = getSelectedOption(select);
    if (!option) return;

    var selectedId = option.value;
    var title = option.getAttribute('data-title') || option.textContent.split('—')[0].trim();
    var price = option.getAttribute('data-price') || '';
    var compare = option.getAttribute('data-compare-at-price') || '';
    var available = option.getAttribute('data-available') === 'true' && !option.disabled;
    var imageUrl = option.getAttribute('data-image-url');
    var imageAlt = option.getAttribute('data-image-alt') || '';
    var imageId = option.getAttribute('data-image-id');

    var priceEl = qs(section, SELECTORS.currentPrice);
    var compareEl = qs(section, SELECTORS.comparePrice);
    var saleBadge = qs(section, SELECTORS.saleBadge);
    var addButton = qs(section, SELECTORS.addButton);
    var addText = qs(section, SELECTORS.addText);
    var addPrice = qs(section, SELECTORS.addPrice);
    var stickyPrice = qs(section, SELECTORS.stickyPrice);
    var stickySelected = qs(section, SELECTORS.stickySelected);
    var stickyImage = qs(section, SELECTORS.stickyImage);
    var stickyCompare = qs(section, SELECTORS.stickyCompare);
    var stickyPriceRow = qs(section, SELECTORS.stickyPriceRow);
    var priceWrapper = qs(section, SELECTORS.priceWrapper);
    var stickyButton = qs(section, SELECTORS.stickySubmit);
    var selectedLabel = qs(section, SELECTORS.selectedVariantLabel);

    if (priceEl) {
      priceEl.textContent = moneyText(price);
      priceEl.classList.toggle('ams-price--sale', Boolean(compare));
    }
    if (stickyPrice) {
      stickyPrice.textContent = moneyText(price);
      stickyPrice.classList.toggle('ams-sticky-price--sale', Boolean(compare));
    }
    if (selectedLabel) selectedLabel.textContent = title;
    if (stickySelected) stickySelected.textContent = title;

    if (compareEl) {
      compareEl.textContent = compare;
      compareEl.classList.toggle('is-hidden', !compare);
    }
    if (stickyCompare) {
      stickyCompare.textContent = compare;
      stickyCompare.classList.toggle('is-hidden', !compare);
    }
    if (priceWrapper) priceWrapper.classList.toggle('is-sale', Boolean(compare));
    if (stickyPriceRow) stickyPriceRow.classList.toggle('is-sale', Boolean(compare));
    if (saleBadge) saleBadge.classList.toggle('is-hidden', !compare);

    if (addButton) {
      addButton.disabled = !available;
      setLoading(addButton, false);
    }

    if (stickyButton) {
      stickyButton.disabled = !available;
      stickyButton.textContent = available ? 'Add to cart' : 'Sold Out';
    }

    if (addText) addText.textContent = available ? 'Add to Cart' : 'Sold Out';
    if (addPrice) {
      addPrice.textContent = moneyText(price);
      addPrice.classList.toggle('is-hidden', !available);
    }

    syncVariantCards(section, selectedId);

    if (imageUrl) {
      setMainProductImage(section, imageUrl, imageAlt, imageId);
      if (stickyImage) {
        stickyImage.src = imageUrl;
        stickyImage.alt = imageAlt || stickyImage.alt || '';
      }
    }

    if (options.updateUrl && selectedId && window.history && window.history.replaceState) {
      var url = new URL(window.location.href);
      url.searchParams.set('variant', selectedId);
      window.history.replaceState({ variant: selectedId }, '', url.toString());
    }

    section.dispatchEvent(new CustomEvent('ams:variant-change', {
      bubbles: true,
      detail: {
        id: selectedId,
        title: title,
        price: price,
        compareAtPrice: compare,
        available: available
      }
    }));
  }

  function selectVariantFromButton(button) {
    if (!button || button.disabled || button.getAttribute('aria-disabled') === 'true') return;
    var section = button.closest(SELECTORS.productSection);
    var select = section && qs(section, SELECTORS.variantSelect);
    var variantId = button.getAttribute('data-variant-id');
    if (!select || !variantId) return;

    var targetOption = qsa(select, 'option').find(function (option) {
      return String(option.value) === String(variantId);
    });

    if (!targetOption || targetOption.disabled) return;

    select.value = variantId;
    updateProductFromVariant(select, { updateUrl: true });
  }

  function moveVariantFocus(currentButton, direction) {
    var section = currentButton.closest(SELECTORS.productSection);
    if (!section) return;
    var buttons = qsa(section, SELECTORS.variantTrigger).filter(function (button) {
      return !button.disabled && button.getAttribute('aria-disabled') !== 'true';
    });
    var index = buttons.indexOf(currentButton);
    if (index === -1) return;
    var next = buttons[(index + direction + buttons.length) % buttons.length];
    if (next) next.focus();
  }

  function getGalleryItems(section) {
    var thumbs = qsa(section, SELECTORS.productThumb);
    if (thumbs.length) {
      return thumbs.map(function (thumb, index) {
        return {
          src: thumb.getAttribute('data-full-image'),
          alt: thumb.getAttribute('data-alt') || '',
          mediaId: thumb.getAttribute('data-media-id'),
          mediaIndex: thumb.getAttribute('data-media-index') || String(index + 1)
        };
      }).filter(function (item) { return Boolean(item.src); });
    }

    var mainImage = qs(section, SELECTORS.mainImage);
    return mainImage ? [{ src: mainImage.src, alt: mainImage.alt || '', mediaId: '', mediaIndex: '1' }] : [];
  }

  function getActiveGalleryIndex(section) {
    var items = getGalleryItems(section);
    if (!items.length) return 0;
    var activeThumb = qs(section, SELECTORS.productThumb + '.is-active');
    if (activeThumb) {
      var activeId = activeThumb.getAttribute('data-media-id');
      var activeIndex = items.findIndex(function (item) { return item.mediaId === activeId; });
      if (activeIndex > -1) return activeIndex;
    }
    var current = qs(section, SELECTORS.galleryCurrent);
    var currentIndex = current ? Number(current.textContent || '1') - 1 : 0;
    return Math.max(0, Math.min(items.length - 1, currentIndex));
  }

  function setLightboxSlide(section, index) {
    var lightbox = qs(section, SELECTORS.lightbox);
    var lightboxImage = qs(section, SELECTORS.lightboxImage);
    var currentEl = qs(section, SELECTORS.lightboxCurrent);
    var items = getGalleryItems(section);
    if (!lightbox || !lightboxImage || !items.length) return;

    var nextIndex = (index + items.length) % items.length;
    var item = items[nextIndex];
    lightbox.setAttribute('data-lightbox-index', String(nextIndex));
    lightboxImage.src = item.src;
    lightboxImage.alt = item.alt || '';
    if (currentEl) currentEl.textContent = String(nextIndex + 1);

    setMainProductImage(section, item.src, item.alt, item.mediaId, item.mediaIndex);

    var hasMultiple = items.length > 1;
    var prev = qs(section, SELECTORS.lightboxPrev);
    var next = qs(section, SELECTORS.lightboxNext);
    if (prev) prev.hidden = !hasMultiple;
    if (next) next.hidden = !hasMultiple;
  }

  function navigateLightbox(section, direction) {
    var lightbox = section && qs(section, SELECTORS.lightbox);
    if (!lightbox || lightbox.hidden) return;
    var index = Number(lightbox.getAttribute('data-lightbox-index') || getActiveGalleryIndex(section));
    setLightboxSlide(section, index + direction);
  }


  function adjustQuantity(button, delta) {
    var stepper = button && button.closest('[data-quantity-stepper]');
    var input = stepper && qs(stepper, '.ams-quantity');
    if (!input) return;

    var min = Number(input.getAttribute('min') || 1);
    var max = input.getAttribute('max') ? Number(input.getAttribute('max')) : Infinity;
    var current = Number(input.value || min);
    if (isNaN(current)) current = min;

    var next = Math.min(max, Math.max(min, current + delta));
    input.value = next;
    input.dispatchEvent(new Event('change', { bubbles: true }));
  }

  function openLightbox(section) {
    var lightbox = qs(section, SELECTORS.lightbox);
    var lightboxImage = qs(section, SELECTORS.lightboxImage);
    if (!lightbox || !lightboxImage) return;
    lightbox.hidden = false;
    document.body.classList.add('overflow-hidden');
    setLightboxSlide(section, getActiveGalleryIndex(section));
    var next = qs(section, SELECTORS.lightboxNext);
    if (next && !next.hidden) next.focus({ preventScroll: true });
  }

  function closeLightbox() {
    qsa(document, SELECTORS.lightbox).forEach(function (lightbox) {
      lightbox.hidden = true;
    });
    document.body.classList.remove('overflow-hidden');
  }


  function escapeHtml(value) {
    return String(value || '').replace(/[&<>'"]/g, function (char) {
      return ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', "'": '&#39;', '"': '&quot;' })[char];
    });
  }

  function formatMoney(cents) {
    var amount = Number(cents || 0) / 100;
    var currency = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'USD';
    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'en-US', { style: 'currency', currency: currency }).format(amount);
    } catch (error) {
      return '$' + amount.toFixed(2);
    }
  }

  function openCartDrawer() {
    var drawer = qs(document, SELECTORS.cartDrawer);
    if (!drawer) return;
    drawer.hidden = false;
    document.body.classList.add('overflow-hidden');
    window.setTimeout(function () { drawer.classList.add('is-open'); }, 20);
  }

  function closeCartDrawer() {
    var drawer = qs(document, SELECTORS.cartDrawer);
    if (!drawer) return;
    drawer.classList.remove('is-open');
    document.body.classList.remove('overflow-hidden');
    window.setTimeout(function () { drawer.hidden = true; }, 220);
  }

  function setCartLoading(isLoading) {
    var drawer = qs(document, SELECTORS.cartDrawer);
    if (drawer) drawer.classList.toggle('is-loading', Boolean(isLoading));
  }

  function renderCart(cart) {
    if (!cart) return;
    qsa(document, SELECTORS.cartCount).forEach(function (count) {
      count.textContent = cart.item_count || 0;
    });

    var itemsEl = qs(document, SELECTORS.cartItems);
    var footerEl = qs(document, SELECTORS.cartFooter);
    if (!itemsEl) return;

    if (!cart.items || !cart.items.length) {
      itemsEl.innerHTML = '<div class="ams-cart-drawer__empty"><strong>Your cart is empty.</strong><span>Find your mattress and add it here.</span><a class="ams-btn ams-btn--accent" href="/collections/all">Shop mattresses</a></div>';
      if (footerEl) footerEl.classList.add('is-hidden');
      return;
    }

    if (footerEl) footerEl.classList.remove('is-hidden');
    itemsEl.innerHTML = cart.items.map(function (item, index) {
      var image = item.image ? '<img src="' + escapeHtml(item.image) + '&width=160" alt="' + escapeHtml(item.product_title) + '" loading="lazy">' : '<div class="ams-cart-drawer__placeholder">A</div>';
      var variant = item.variant_title && item.variant_title !== 'Default Title' ? '<span>' + escapeHtml(item.variant_title) + '</span>' : '';
      return '<div class="ams-cart-drawer__item">' +
        '<a class="ams-cart-drawer__image" href="' + escapeHtml(item.url) + '">' + image + '</a>' +
        '<div class="ams-cart-drawer__meta"><a href="' + escapeHtml(item.url) + '"><strong>' + escapeHtml(item.product_title) + '</strong></a>' + variant + '<small>Qty ' + item.quantity + '</small><button type="button" data-cart-remove="' + (index + 1) + '">Remove</button></div>' +
        '<div class="ams-cart-drawer__price">' + formatMoney(item.final_line_price) + '</div>' +
      '</div>';
    }).join('') + '<div class="ams-cart-drawer__subtotal"><span>Subtotal</span><strong>' + formatMoney(cart.total_price) + '</strong></div>';
  }

  function fetchCart(options) {
    options = options || {};
    setCartLoading(true);
    return fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (response) { return response.json(); })
      .then(function (cart) {
        renderCart(cart);
        if (options.open) openCartDrawer();
        return cart;
      })
      .catch(function () {
        if (options.open) window.location.href = '/cart';
      })
      .finally(function () { setCartLoading(false); });
  }

  function ajaxAddToCart(form) {
    var button = qs(form, SELECTORS.addButton);
    setLoading(button, true);
    setCartLoading(true);
    return fetch('/cart/add.js', {
      method: 'POST',
      body: new FormData(form),
      headers: { 'Accept': 'application/json' }
    })
      .then(function (response) {
        if (!response.ok) throw new Error('Add to cart failed');
        return response.json();
      })
      .then(function () { return fetchCart({ open: true }); })
      .catch(function () {
        if (button) setLoading(button, false);
        HTMLFormElement.prototype.submit.call(form);
      })
      .finally(function () {
        if (button) setLoading(button, false);
        setCartLoading(false);
      });
  }


  function parseSaleDeadline(value) {
    if (value) {
      var explicit = new Date(value);
      if (!isNaN(explicit.getTime()) && explicit.getTime() > Date.now()) return explicit;
    }
    var now = new Date();
    return new Date(now.getFullYear(), now.getMonth(), now.getDate(), 23, 59, 59);
  }

  function initSaleCountdowns() {
    qsa(document, '[data-sale-countdown]').forEach(function (bar) {
      var hoursEl = qs(bar, '[data-countdown-hours]');
      var minutesEl = qs(bar, '[data-countdown-minutes]');
      var secondsEl = qs(bar, '[data-countdown-seconds]');
      if (!hoursEl || !minutesEl || !secondsEl) return;

      function pad(value) {
        return String(Math.max(0, value)).padStart(2, '0');
      }

      function tick() {
        var deadline = parseSaleDeadline(bar.getAttribute('data-countdown-deadline'));
        var diff = Math.max(0, deadline.getTime() - Date.now());
        var totalSeconds = Math.floor(diff / 1000);
        var hours = Math.floor(totalSeconds / 3600);
        var minutes = Math.floor((totalSeconds % 3600) / 60);
        var seconds = totalSeconds % 60;

        hoursEl.textContent = pad(hours);
        minutesEl.textContent = pad(minutes);
        secondsEl.textContent = pad(seconds);
      }

      tick();
      window.setInterval(tick, 1000);
    });
  }

  function initProductSections() {
    qsa(document, SELECTORS.productSection).forEach(function (section) {
      var select = qs(section, SELECTORS.variantSelect);
      if (select) updateProductFromVariant(select, { updateUrl: false });
    });
  }

  function initStickyAtcVisibility() {
    qsa(document, '[data-sticky-atc]').forEach(function (sticky) {
      var section = sticky.closest(SELECTORS.productSection);
      var purchaseCard = section && qs(section, '.ams-product-purchase-card');
      if (!purchaseCard) return;

      function updateStickyState() {
        var isMobile = window.matchMedia('(max-width: 640px)').matches;
        if (!isMobile) {
          sticky.classList.remove('is-visible');
          return;
        }
        sticky.classList.toggle('is-visible', purchaseCard.getBoundingClientRect().bottom < 0);
      }

      updateStickyState();
      window.addEventListener('scroll', updateStickyState, { passive: true });
      window.addEventListener('resize', updateStickyState);
    });
  }

  document.addEventListener('click', function (event) {
    var cartClose = event.target.closest(SELECTORS.cartClose);
    if (cartClose) {
      closeCartDrawer();
      return;
    }

    var cartOpen = event.target.closest(SELECTORS.cartOpen);
    if (cartOpen) {
      event.preventDefault();
      fetchCart({ open: true });
      return;
    }

    var cartRemove = event.target.closest('[data-cart-remove]');
    if (cartRemove) {
      setCartLoading(true);
      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ line: Number(cartRemove.getAttribute('data-cart-remove')), quantity: 0 })
      }).then(function (response) { return response.json(); })
        .then(renderCart)
        .finally(function () { setCartLoading(false); });
      return;
    }

    var mobileToggle = event.target.closest(SELECTORS.mobileMenuToggle);
    if (mobileToggle) {
      var panel = qs(document, SELECTORS.mobileMenuPanel);
      if (panel) {
        var isOpen = panel.classList.toggle('is-open');
        mobileToggle.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
      }
      return;
    }

    var mobileLink = event.target.closest('[data-mobile-menu-panel] a');
    if (mobileLink) closeMobileMenu();

    var faqButton = event.target.closest('[data-faq-toggle]');
    if (faqButton) {
      var item = faqButton.closest('.ams-faq-item');
      if (item) item.classList.toggle('is-open');
      return;
    }

    var qtyMinus = event.target.closest('[data-qty-decrement]');
    if (qtyMinus) {
      adjustQuantity(qtyMinus, -1);
      return;
    }

    var qtyPlus = event.target.closest('[data-qty-increment]');
    if (qtyPlus) {
      adjustQuantity(qtyPlus, 1);
      return;
    }

    var variantButton = event.target.closest(SELECTORS.variantTrigger);
    if (variantButton) {
      selectVariantFromButton(variantButton);
      return;
    }

    var thumb = event.target.closest(SELECTORS.productThumb);
    if (thumb) {
      var section = thumb.closest(SELECTORS.productSection);
      if (!section) return;
      setMainProductImage(
        section,
        thumb.getAttribute('data-full-image'),
        thumb.getAttribute('data-alt'),
        thumb.getAttribute('data-media-id'),
        thumb.getAttribute('data-media-index')
      );
      return;
    }

    var galleryOpen = event.target.closest('[data-gallery-open]');
    if (galleryOpen) {
      var gallerySection = galleryOpen.closest(SELECTORS.productSection);
      if (gallerySection) openLightbox(gallerySection);
      return;
    }

    var lightboxPrev = event.target.closest(SELECTORS.lightboxPrev);
    if (lightboxPrev) {
      var prevSection = lightboxPrev.closest(SELECTORS.productSection);
      navigateLightbox(prevSection, -1);
      return;
    }

    var lightboxNext = event.target.closest(SELECTORS.lightboxNext);
    if (lightboxNext) {
      var nextSection = lightboxNext.closest(SELECTORS.productSection);
      navigateLightbox(nextSection, 1);
      return;
    }

    if (event.target.closest('[data-lightbox-close]') || event.target.matches(SELECTORS.lightbox)) {
      closeLightbox();
      return;
    }

    var stickyButton = event.target.closest(SELECTORS.stickySubmit);
    if (stickyButton) {
      var productSection = stickyButton.closest(SELECTORS.productSection);
      var submitButton = productSection && qs(productSection, SELECTORS.addButton);
      if (submitButton && !submitButton.disabled) submitButton.click();
    }
  });

  document.addEventListener('change', function (event) {
    var select = event.target.closest(SELECTORS.variantSelect);
    if (select) updateProductFromVariant(select, { updateUrl: true });
  });

  document.addEventListener('keydown', function (event) {
    var variantButton = event.target.closest && event.target.closest(SELECTORS.variantTrigger);
    if (variantButton) {
      if (event.key === 'ArrowRight' || event.key === 'ArrowDown') {
        event.preventDefault();
        moveVariantFocus(variantButton, 1);
        return;
      }
      if (event.key === 'ArrowLeft' || event.key === 'ArrowUp') {
        event.preventDefault();
        moveVariantFocus(variantButton, -1);
        return;
      }
      if (event.key === ' ' || event.key === 'Enter') {
        event.preventDefault();
        selectVariantFromButton(variantButton);
        return;
      }
    }

    var openLightboxEl = qs(document, SELECTORS.lightbox + ':not([hidden])');
    if (openLightboxEl && (event.key === 'ArrowLeft' || event.key === 'ArrowRight')) {
      var openSection = openLightboxEl.closest(SELECTORS.productSection);
      navigateLightbox(openSection, event.key === 'ArrowRight' ? 1 : -1);
      return;
    }

    if (event.key === 'Escape') {
      closeLightbox();
      closeMobileMenu();
      closeCartDrawer();
    }
  });

  document.addEventListener('submit', function (event) {
    var form = event.target.closest('.ams-product-form');
    if (!form) return;
    var button = qs(form, SELECTORS.addButton);
    if (button && button.disabled) return;
    event.preventDefault();
    ajaxAddToCart(form);
  });

  qsa(document, SELECTORS.lightbox).forEach(function (lightbox) {
    var startX = 0;
    lightbox.addEventListener('touchstart', function (event) {
      startX = event.changedTouches && event.changedTouches[0] ? event.changedTouches[0].clientX : 0;
    }, { passive: true });
    lightbox.addEventListener('touchend', function (event) {
      var endX = event.changedTouches && event.changedTouches[0] ? event.changedTouches[0].clientX : 0;
      var delta = endX - startX;
      if (Math.abs(delta) > 44) {
        var section = lightbox.closest(SELECTORS.productSection);
        navigateLightbox(section, delta < 0 ? 1 : -1);
      }
    }, { passive: true });
  });

  initSaleCountdowns();
  initProductSections();
  initStickyAtcVisibility();
})();
